<template>
    <div v-if="viewEmployeeAwards" class="idea-challenges">
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
      <transition name="fade">
        <div v-if="contentReady && contentLoadError === ''">
          <!--<ContentHeader :name="award.title.rendered"></ContentHeader>-->
          <ContentHeader name="EMPLOYEE RECOGNITION"></ContentHeader>
          <section>
            <div class="card mb-3">
              <div v-if="award._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
                <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                  :title="award._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div v-if="award.include_nomination_form[0] === 'Yes'" v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
              <div v-if="award.nomination_event_time_frame.length > 0">
                <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                  <li class="h6">
                    <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                  </li>
                </ul>
              </div>
              <!-- <ChildNominationEventsList v-if="award.child_nomination_awards.length > 0 && award.child_nomination_awards[0] !== []" class="px-3 pb-3" :awards="award.child_nomination_awards[0][0]" name="The awards categories are:"></ChildNominationEventsList> -->
              <div v-if="madeNomination" class="px-3 pb-3">
                <div class="alert alert-success" role="alert">
                  Congratulations, you've nominated:
                  <ul>
                    <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                      <strong>{{teams.name}}</strong> from {{teams.country}} -
                      Employee number: <strong>{{teams.employeeNum}}</strong><br>
                      Department: <strong>{{teams.department}}</strong><br>
                      Company: <strong>{{teams.company}}</strong><br>
                    </li>
                  </ul>
                </div>
                <button type="button" name="button" class="btn btn-primary" v-on:click="removeNominee()">Nominate someone else</button>
              </div>
              <div v-if="award.include_nomination_form[0] === 'Yes' && award.nomination_fields.length > 0 && !madeNomination" class="px-3 pb-3">
                <h4 class="mb-3">{{NominationLabel}}</h4>
                <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                  <div class="input-group input-group-lg mb-4">
                    <vue-bootstrap-typeahead class="form-control" v-model="nominatedPerson" :data="nomineesList" @keydown.enter="search" :serializer="item => item.email" placeholder="Search by email address" prepend="" ></vue-bootstrap-typeahead>
                    <!-- <input type="text" class="form-control" :placeholder="NominationPlaceholder" v-model="nominatedPerson" required> -->
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit" :disabled="nominatedPerson.length === 0" v-on:click="setNominee()">{{NominationButtonText}}</button>
                      <!--button class="btn btn-primary" type="submit" :disabled="nominatedPerson.length === 0">{{NominationButtonText}}</button-->
                    </div>
                  </div>
                </form>
                <PreContentHeader :show-loading="searchingForEmployee" :error-message="searchingForEmployeeError"></PreContentHeader>
                <div class="p-3 mb-2 bg-primary text-white border border-primary font-weight-bold mt-1" v-if="NominationTeamNames.length === 1">Continue to add names if you would like to complete a team nomination for Teams nomination</div>
                <transition name="grow">
                  <div v-if="showNominationForm || NominationTeamNames.length > 0">
                    <hr>
                    <strong>You are nominating:</strong><br>
                    <div v-if="isTeamAwards">
                      <ul>
                        <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                          <strong>{{teams.name}}</strong> from {{teams.country}} -
                          Employee number: <strong>{{teams.employeeNum}}</strong><br>
                          Department: <strong>{{teams.department}}</strong><br>
                          Company: <strong>{{teams.company}}</strong><br>
                          <button type="button" class="btn btn-link p-0" v-on:click="removeTeamNominee(teams)">X Remove</button>
                        </li>
                      </ul>
                    </div>
                    <hr>
                    <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                      <div v-for="formField in nominationFields" v-bind:key="formField.index">
                        <NominationField
                          :type="formField.type"
                          :description="formField.description"
                          :secondary-description="formField.secondaryDescription"
                          :description-lvl-two="formField.description_lvl_two"
                          :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                          :is-required="formField.isRequired"
                          :checkbox-labels="formField.checkboxLabels"
                          v-on:updatedFieldContent="fieldUpdated($event)"
                          :validationMethod="formField.validationMethod"
                          :displayField="formField.display_field"
                          :error-class="formField.errorClass">
                        </NominationField>
                      </div>
                      <div class="row py-1">
                        <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                          <div class="form-group form-check">
                            <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                            <label for="terms" class="form-check-label">Nomination Complete. I accept the 
                              <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row pt-2 mb-4">
                        <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
                          <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </transition>
                <PreContentHeader :show-loading="creatingNomination" :error-message="createNominationError"></PreContentHeader>
              </div>
              <div v-if="award.include_nomination_form[0] === 'No'">
                <div class="p-4">
                  <h4>Form Currently Unavailable</h4>
                  <hr>
                  <p>We're sorry, but the form you are trying to access is currently unavailable. If you have any questions or concerns, please don't hesitate to contact our HR team for assistance.</p>
                </div>
              </div>
            </div>
          </section>
          <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
            <div class="card-body" v-html="award.additional_content[0]"></div>
          </div>
        </div>
      </transition>
    </div>
    <div v-else>
      <!--h5> You do not have permission to access this page. Please contact HR team to provide role.</h5-->
    </div>
  </template>
  
  <script>
  import ContentHeader from '@/components/ContentHeader'
  import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
  import WordpressRestURI from '@/helpers/WordpressRestURI.js'
  import ADauthentication from '@/helpers/ADauthentication.js'
  import NominationNotification from '@/helpers/NominationNotification.js'
  import ChildNominationEventsList from '@/components/ChildNominationEventsList'
  import NominationField from '@/components/NominationField'
  import Loading from '@/components/Loading'
  import PreContentHeader from '@/components/PreContentHeader'
  import vueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
        award: [],
        errors: [],
        contentReady: false,
        contentLoadError: '',
        nominationContent: [],
        nominationFields: [],
        nominatedPerson: '',
        madeNomination: false,
        termsCheckbox: false,
        validatedNominee: '',
        showNominationForm: false,
        creatingNomination: false,
        createNominationError: '',
        searchingForEmployee: false,
        searchingForEmployeeError: '',
        isContractorErrorSet: true,
        isTeamAwards: false,
        submitClicked: true,
        NominationButtonText: 'Nominate',
        NominationLabel: 'Nominate an Employee for this Award',
        NominationPlaceholder: 'Search by name and surname or email address...',
        NominationTeamNames: [],
        NominationTeamsContent: [],
        nomineesList: [],
        employeeHierarchy: {},
        options: [],
        selectedOption: '',
        supportingDocList: [],
        supportingDocLength: 0
      }
    },
    components: {
      PreContentHeader,
      ContentHeader,
      ChildNominationEventsList,
      NominationField,
      Loading,
      vueBootstrapTypeahead
    },
    computed: {
      ...mapGetters([
        'viewEmployeeAwards'
      ])
    },
    methods: {
      setValidatedNominee: function (userData) {
        if (this.checkForDuplicateNominee(userData)) {
          this.validatedNominee = {
            name: userData.firstname + ' ' + userData.lastname,
            slug: userData.email.replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
            department: userData.department,
            company: (userData.company === '') ? 'Multichoice' : userData.company,
            employeeNum: userData.employeenumber,
            country: userData.country,
            email: userData.UPN,
            lineManagerName: (!userData.managername) ? userData.employeehierarchy['line-manager-name'][0] : userData.managername,
            lineManagerEmail: (!userData.manageremail) ? userData.employeehierarchy['line-manager-email'][0] : userData.manageremail,
            employeeHierarchy: userData.employeehierarchy
          }
          this.NominationTeamNames.push(this.validatedNominee)
          this.getPageLabel()
        }
      },
      // code to get Label of page
      getPageLabel: function() {
        if (this.NominationTeamNames.length > 1) {
          this.NominationLabel = "Team Of The Month"
        }
        else {
          this.NominationLabel = "Employee Of The Month"
        }
        for (var i = 0; i < this.nominationFields.length; i++) {
          console.log(' 215 ', this.nominationFields[i], this.NominationLabel)
          
          if (this.nominationFields[i].description === 'Why are you nominating this person?' || this.nominationFields[i].description === 'Why are you nominating this team?') {
            console.log('217 ', this.nominationFields[i].description)
            if (this.NominationLabel === "Team Of The Month") {
              this.nominationFields[i].description = 'Why are you nominating this team?'
            }
            if (this.NominationLabel === "Employee Of The Month") {
              this.nominationFields[i].description = 'Why are you nominating this person?'
            }
            console.log(' 224 ', this.nominationFields[i].description)
            break;
          }
        }

        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].label === 'Why are you nominating this person?'  || this.nominationContent[i].label === 'Why are you nominating this team?') {
            console.log('233 ', this.nominationContent[i].label)
            if (this.NominationLabel === "Team Of The Month") {
              this.nominationContent[i].label = 'Why are you nominating this team?'
            }
            if (this.NominationLabel === "Employee Of The Month") {
              this.nominationContent[i].label = 'Why are you nominating this person?'
            }
            console.log(' 240 ', this.nominationContent[i].label)
            break;
          }
        }
      },
      searchLocalDB: function () {
        this.searchingForEmployeeError = ''
        WordpressRestAPI.getLocalDbUserLookup(this.nominatedPerson.toLowerCase())
          .then(response => {
          if (this.checkForDuplicateNominee(response.data))
            this.setValidatedNominee(response.data)
            if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
              this.showNominationForm = false
              this.searchingForEmployee = false
              alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
              this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            } else {
              this.showNominationForm = true
              this.searchingForEmployee = false
            }
          })
          .catch(e => {
            if (this.isContractorErrorSet) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
            }
            this.isContractorErrorSet = true
            console.error(e)
          })
      },
      searchByEmail: function () {
        this.searchingForEmployeeError = ''
        ADauthentication.getUserInfoByEmail(this.nominatedPerson)
          .then(response => {
            console.log(response.data)
            this.setValidatedNominee(response.data)
            this.showNominationForm = true
            this.searchingForEmployee = false
          })
          .catch(e => {
            if (this.isContractorErrorSet) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'We could not find a user with the email: ' + this.nominatedPerson + '. Make sure you entered the correct email address or try searching by name and surname'
            }
            this.isContractorErrorSet = true
            console.error(e)
          })
      },
      searchByUsername: function () {
        this.searchingForEmployeeError = ''
        ADauthentication.getUserInfoByUsername(this.nominatedPerson.replace(' ', '.').toLowerCase())
          .then(response => {
            console.log(response.data)
            this.setValidatedNominee(response.data)
            if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
              this.showNominationForm = false
              this.searchingForEmployee = false
              alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
              this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            } else {
              this.showNominationForm = true
              this.searchingForEmployee = false
            }
          })
          .catch(e => {
            if (this.isContractorErrorSet) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
            }
            this.isContractorErrorSet = true
            console.error(e)
          })
      },
      checkForDuplicateNominee: function(data) {
        var self = this
        if (!data.email) {
          data.email = data.UPN
        }
        if (data.email) {
            var dupliEmail = []
            if (self.NominationTeamNames.length > 0) {
                dupliEmail = self.NominationTeamNames.filter(d => data.email && d.email.toLowerCase() ===  data.email.toLowerCase() || d.name.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase())
            }
            if (data.email && self.$store.getters.getUserEmail.toLowerCase() === data.email.toLowerCase() || self.$store.getters.getUserName.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase()) {
                dupliEmail.push(data.email)
                self.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
                return false
            }
            if (dupliEmail.length > 0) {
                self.searchingForEmployeeError = 'Duplicate Nominee ' + data.email
                return false
            }
            if (data.employeehierarchy) {
              if (data.employeehierarchy.ishod[0] ===  'Yes') {
                self.searchingForEmployeeError = 'SELECTED NOMINEE '  + data.email + ' IS HOD (OR ABOVE) AND CANNOT BE NOMINATED'
                return false
              }
            }
            if (data.employeehierarchy === false) {
                self.searchingForEmployeeError = 'Nominee ' + data.email + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
                return false
            }
            return true
        } else if (data.upn) {
          console.log(' data.upn ', data.upn)
        } else {
          self.searchingForEmployeeError = 'Nominee ' + self.nominatedPerson + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
            return false
        }
      },
      getStatus: function () {
        let status = true
        let emailSlug = this.nominatedPerson.replace(/\./g, '-').replace(/@/g, '').toLowerCase()
        let urlString = '?slug='+emailSlug+'&type=EOM'
        console.log('urlString : '+urlString)
        WordpressRestAPI.getCustomViewContent('getNomination/v1/getUserNominationPerEOM'+urlString)
        .then(response => {
          console.log('review list-> ', response.data)
          if (response.data !== false) {
            console.log('review list-> ', response.data.EOM_count, response.data.TOM_count)
            //if (response.data && response.data.EOM_count && response.data.TOM_count) {
            if (response.data) {              
              // Loop through user_count
              this.createNominationError = ''
              console.log(' 371 ')
              // Check if userStatus is false and alert
              if (response.data.EOM_count > 0) {
                alert(`Employee ${this.nominatedPerson} has already received a nomination this month. As per policy, each user may be nominated only once per calendar month.`)
              } else if (response.data.TOM_count > 0) {
                alert(`Employee ${this.nominatedPerson} has already received a nomination this month. As per policy, each user may be nominated only once per calendar month.`)
              } else {
                this.setNominee()
              }
            }
          } else {
            this.contentReady = true
            this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
          }
        })
        .catch(e => {
            this.contentReady = true
            this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
            console.error(e)
        })
      },
      // code to add user to Nomination list
      setNominee: function () {
        this.searchingForEmployee = true
        this.searchingForEmployeeError = ''
        if (this.isTeamAwards) {
          if (this.nominatedPerson.split(',').length > 50) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'Team Member count can\'t exceed 50!'
          }
          var self = this
          if (this.searchingForEmployee) {
            this.nominatedPerson.split(',').map(function (val, index) {
              let valOrg = val.trim()
              val = val.trim().toLowerCase()
              var dupEmail = self.NominationTeamNames.filter(d => d.email.toLowerCase() === val)
              var dupName = 0
              if (val.indexOf('@') > -1) {
                dupName = self.NominationTeamNames.filter(d => d.name.toLowerCase() === val)
              }
              if (dupEmail.length > 0 || dupName > 0) {
                self.searchingForEmployee = false
              } else if (val !== '') {
                if (val.toLowerCase().indexOf('irdeto') > -1) {
                  alert('Irdeto can\'t be nominated for this Awards.')
                  self.searchingForEmployeeError = 'Irdeto can\'t be nominated for this Awards'
                  self.searchingForEmployee = false
                } else if (self.$store.getters.getUserEmail.toLowerCase() === val.trim().toLowerCase() || self.$store.getters.getUserName.toLowerCase() === val.trim().toLowerCase()) {
                  alert('You can\'t nominate yourself.')
                  self.searchingForEmployeeError = 'You can\'t nominate yourself'
                  self.searchingForEmployee = false
                } else {
                  console.log('valOrg', valOrg)
                  if (val.indexOf('@') > -1) {
                    ADauthentication.getUserInfoByEmail(valOrg)
                      .then(response => {
                        self.setValidatedNominee(response.data)
                        if (self.NominationTeamNames.length > 1) {
                          self.showNominationForm = true
                        }
                        self.searchingForEmployee = false
                      })
                      .catch(e => {
                        self.searchingForEmployee = false
                        self.searchingForEmployeeError = 'Unable to find the Nominee; Please try again!'
                        console.error(e)
                      })
                  } else {
                    ADauthentication.getUserInfoByUsername(val.replace(' ', '.').toLowerCase())
                      .then(response => {
                        console.log(response.data)
                        self.setValidatedNominee(response.data)
                        console.log('NominationTeamNames Length', self.NominationTeamNames.length)
                        if (self.NominationTeamNames.length > 1) {
                          self.showNominationForm = true
                        }
                        self.searchingForEmployee = false
                      })
                      .catch(e => {
                        self.searchingForEmployee = false
                        self.searchingForEmployeeError = 'We could not find a user with the names: ' + val + '. Make sure you entered the correct name and surname or try searching by email'
                        console.error(e)
                      })
                  }
                }
              }
            })
          }
        } else
        if (this.nominatedPerson.toLowerCase().indexOf('irdeto') > -1 || this.nominatedPerson.toLowerCase().indexOf('showmax') > -1) {
          if ((this.$route.params.name === 'employee-of-the-year-2018' || this.$route.params.name === 'team-awards-2018') && this.nominatedPerson.toLowerCase().indexOf('showmax') === -1) {
            alert('Irdeto can\'t be nominated for this Awards. Please nominate your colleagues for Innovation Awards.')
            this.searchingForEmployee = false
          } else if (this.$store.getters.getUserEmail.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
            this.searchLocalDB()
          } else {
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            this.searchingForEmployee = false
          }
        } else if (this.nominatedPerson.indexOf('@') > -1) {
          if (this.$store.getters.getUserEmail.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
            this.searchByEmail()
          } else {
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            this.searchingForEmployee = false
          }
        } else {
          if (this.$store.getters.getUserName.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
            this.searchByUsername()
          } else {
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            this.searchingForEmployee = false
          }
        }
      },
      // Below code is to remove all members. This function is used for Nominate someone else
      removeNominee: function () {
        this.validatedNominee = {name: '', department: '', employeeNum: ''}
        this.showNominationForm = false
        this.nominatedPerson = ''
        this.madeNomination = false
        this.NominationTeamNames = []
        this.submitClicked = true
        this.nominationContent = []
        this.termsCheckbox = false
        this.setNominationContent(this.award.nomination_fields[0][0])
      },
      // Remove single user
      removeTeamNominee: function (index) {
        this.NominationTeamNames.splice(this.NominationTeamNames.indexOf(index), 1)
        if (this.NominationTeamNames.length === 0) {
          this.showNominationForm = false
        }
        this.getPageLabel()
        var slugArray = this.NominationTeamNames.map(function(member) {
            return member.slug;
        });
        // Convert the 'emailArray' to a string with a comma as the separator
        var slugString = slugArray.join(',')
        if (slugString) {
          this.submitClicked = true
        }
      },
      setPostContent: function (type) {
        var content = ''
        var plainContent = ''
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].displayField)
            if (this.nominationContent[i].label === 'Why are you nominating this person?' || this.nominationContent[i].label === 'Why are you nominating this team?') {
              content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
              plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
            }
        }
        return (type === 'nohtml' ? plainContent : content)
      },
      getSelectedPeriod: function() {
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].displayField)
            if (this.nominationContent[i].label === 'Month') {
              return this.nominationContent[i].content
            }
        }
        return ''
      },
      ValidateFields: function (value, type, label) {
        if (type.toLowerCase() === 'email') {
          if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
            alert('Invalid ' + label + ' !')
            return false
          } else if (value.split('@').length > 2) {
            alert ('Only one mail allowed for ' + label + ' !' )
            return false
          }
          return true
        }
      },
      // code to check Nomination Field and Nomination Content for validation
      readyToSubmitNomination: function () {
        var contentPassedValidation = true
        this.searchingForEmployeeError = ''
        for (var j = 0; j < this.nominationContent.length; j++) {
          this.nominationFields[j].errorClass = ''
          if (this.nominationFields[j].display_field === false) {
            continue
          } else {
            if (this.nominationFields[j].validationMethod) {
              contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
            }
            if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
              this.nominationContent[j].validated = true
            }
            if (this.nominationContent[j].validated === false) {
              contentPassedValidation = false
              this.nominationFields[j].errorClass = 'field-not-validated'
            }
            if (this.isTeamAwards) {
              if (this.NominationTeamNames.length > 50) {
                this.searchingForEmployeeError = 'Team Member count can\'t exceeds 50!'
                contentPassedValidation = false
              }
            }
            // Stop immedieatly any field validation is false
            if (contentPassedValidation === false)
              break;
          }
        }
        console.log(' this.termsCheckbox ', this.termsCheckbox, contentPassedValidation, 'result ', this.termsCheckbox && contentPassedValidation)
        return this.termsCheckbox && contentPassedValidation
      },
      addMediaToNominationPost: function (mediaID, postID) {
        var sendNomination = {
          method: 'POST',
          data: {
            supporting_documentation: mediaID
          },
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + postID)
          .then(function (response) {
            self.supportingDocLength = 0
            self.supportingDocList = []
          })
          .catch(function (e) {
            console.error(e)
          })
      },
      uploadSupportingDocumentation: function (postID, supportingDoc) {
        var self = this
        var formData = new FormData()
        formData.append('file', supportingDoc)
        if (self.NominationTeamNames.length === 1) {
          //Employee of the month
          formData.append('title', postID + ' Supporting Image Media of Employee of the Month for ' + self.validatedNominee.name)
          formData.append('caption', postID + ' Supporting Image Media of Employee of the Month for ' + self.validatedNominee.name)
        } else if (self.NominationTeamNames.length) {
          //Teams of the month
          formData.append('title', postID + ' Supporting Image Media for Team of the Month by ' + self.$store.getters.getUserName)
          formData.append('caption', postID + ' Supporting Image Media for Team of the Month by ' + self.$store.getters.getUserName)
        }
        var uploadMedia = {
          method: 'POST',
          processData: false,
          contentType: false,
          data: formData,
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
          .then(function (response) {
            self.supportingDocList.push(response.data.id)
            if (self.supportingDocLength === self.supportingDocList.length) {
              self.addMediaToNominationPost(self.supportingDocList, postID)
            }
          })
          .catch(function (e) {
            console.error(e)
          })
      },
      checkForMediaUpload: function (postID) {
        var supportingDoc = this.nominationContent.filter(x => {
          return x.label.indexOf('If applicable, please attach Image for Award') > -1 && x.content !== ''
        })
        if (supportingDoc.length > 0) {
          //this.uploadSupportingDocumentation(postID, supportingDoc[0].content)
          const filesArray = Array.from(supportingDoc[0].content)
          // Traverse the array using forEach
          this.supportingDocLength = supportingDoc[0].content.length
          filesArray.forEach(file => {
            this.uploadSupportingDocumentation(postID, file)
          });
        }
      },
      assignUserCommunities: function () {
        console.log('assignUserCommunities ', this.$store.getters.getUserCommunityIDstring)
        if (this.$store.getters.getUserCommunityIDstring) {  
        return this.award.community_categories.filter(
          f => this.$store.getters.getUserCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
        )
        } else {
            return []
        }  
        /*return this.award.community_categories.filter(
          f => this.$store.getters.getUserCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
        )*/
      },
      getNominationEventCategory: function () {
        var self = this
        var nominationEventCategory = []
        nominationEventCategory.push('20')
        if (self.NominationTeamNames.length === 1) {
        // On the Spot
          nominationEventCategory.push('100')
        } else if (self.NominationTeamNames.length) {
        // Teams
          nominationEventCategory.push('138')
        }
        return nominationEventCategory
      },
      getNominationTitle: function () {
        var self = this
        var nominationTitle = ''
        if (self.NominationTeamNames.length === 1){
          nominationTitle = self.validatedNominee.name + ', Employee of the Month'
        }
        else if (self.NominationTeamNames.length > 1){
          nominationTitle = 'Team of the month by ' + self.$store.getters.getProfileDetails.name
        }
        return nominationTitle
      },
      // Below code is for submitting Nomination form
      createNominationEntry: function () {
        this.showNominationForm = false
        this.creatingNomination = true
        var self = this
        if (self.$store.state.UserProfile.currentUser.meta.communities !== undefined && self.$store.state.UserProfile.currentUser.meta.communities.length > 0) {
          var employeeCompany = self.$store.state.UserProfile.currentUser.meta.communities
        } else {
          var employeeCompany = self.validatedNominee.department
        }
        console.log('createNominationEntry self.validatedNominee.department ', self.validatedNominee, self.validatedNominee.department, self.$store.state.UserProfile.currentUser, self.$store.state.UserProfile.currentUser.meta.communities)
        if (self.$store.state.UserProfile.currentUser.meta.employeeNumber !== undefined && self.$store.state.UserProfile.currentUser.meta.employeeNumber.length > 0) {
          var employeeNumber = self.$store.state.UserProfile.currentUser.meta.employeeNumber
        } else {
          var employeeNumber = self.validatedNominee.employeeNum
        }
        var sendNomination = {
          method: 'POST',
          data: {
            title: self.getNominationTitle(),
            nomination_event_category: self.getNominationEventCategory(),
            community_categories: self.assignUserCommunities(),
            nomination_approve_decline: 'Accepted',
            nominee_name: self.validatedNominee.name,
            nominee_slug: self.validatedNominee.slug,
            nominee_company: self.validatedNominee.company,
            status: 'publish',
            content: self.setPostContent('html'),
            nominationdata: self.setPostContent('nohtml'),
            selectionperiod: self.getSelectedPeriod(),
            nominator_details: [{
              'employee-number': employeeNumber,
              'employee-company': employeeCompany
            }]
          },
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        var parentName = ''
        sendNomination.data.bigups_ecards = []
        sendNomination.data.teamnominationworkflow = []
        var d = new Date()
        let nominationDate = d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()

        // Push Line Manager
        if (self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0]) {
          sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Manager', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})
        }

        // Push Exco2 Manager
        if (self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0]) {
          sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Exco2', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': '', 'project_sponsor_datetime' : ''})
        }

        // Push HRBP
        if (self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0]) {
          sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'HRBP', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status' : 'Approve', 'project_sponsor_datetime': nominationDate})
        }
        if (self.NominationTeamNames.length > 1) {
          sendNomination.data.isteamaward = 'true'
        }
        if (self.NominationTeamNames.length > 1) {
          sendNomination.data.nominationteam = []
          sendNomination.data.nominee_name = ''
          sendNomination.data.nominee_slug = ''
          for (var i = 0; i < self.NominationTeamNames.length; i++) {
            sendNomination.data.nominationteam.push({
              'member_name': self.NominationTeamNames[i].name,
              'member_approve_reject': 'Accepted',
              'member_company': self.NominationTeamNames[i].company,
              'member_employee_number': self.NominationTeamNames[i].employeeNum,
              'member_slug': self.NominationTeamNames[i].slug,
              'email': self.NominationTeamNames[i].email
            })
          }
        }
        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination')
        .then(function (response) {
          self.checkForMediaUpload(response.data.id)
          self.promoteToReview(response.data, 'exco2', 'Exco2')
          self.madeNomination = true
          self.creatingNomination = false
        })
        .catch(function (e) {
          self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
          console.error(e)
        })
      },
      promoteToReview: function (nominationDetails, reviewer, reviewerLabel) {
        let emailBody = ''
        var tempEmail = []
        if (nominationDetails.id) {
          var title = nominationDetails.title.raw.toLowerCase()
          if (title.includes('employee')) {
            var nominationType = 'AN Employee of the Month'
          }
          if (title.includes('team')) {
            var nominationType = 'A Team of the Month'
          }
          // TODO: Change the Email template once received
          emailBody = NominationNotification.nominationBodyForEmployeeAwardNotification({
            reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-employee-award+' + nominationDetails.id + '+' + reviewerLabel,
            position: reviewerLabel,
            nominationType: nominationType
          })
          tempEmail = nominationDetails.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === reviewer.toLowerCase())
          var emailNominationNotification = {
            method: 'POST',
            data: {
              to: tempEmail[0].project_sponsor_email,
              subject: 'You have been identified as ' + reviewerLabel + ' on ThinkTank',
              message: emailBody
            },
            json: true
          }
          WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
          })
        }
      },
      submitNomination: function () {
        this.submitClicked = false
        if (this.readyToSubmitNomination()) {
          var selectionPeriod = this.getSelectedPeriod()
          let emailSlug = ''
          let urlString = ''
          console.log(' this.NominationTeamNames ', this.NominationTeamNames, this.NominationTeamNames.length)
          if (this.NominationTeamNames.length === 1) {
            // On the Spot
            emailSlug = this.nominatedPerson.replace(/\./g, '-').replace(/@/g, '').toLowerCase()
            urlString = '?slug='+emailSlug+'&type=EOM&selectionPeriod='+selectionPeriod
          } else if (this.NominationTeamNames.length > 1) {
            // Teams
            for (let index = 0; index < this.NominationTeamNames.length; index++) {
              console.log(' this.NominationTeamNames ', this.NominationTeamNames[index], index)
              if (index == 0) {
                emailSlug = this.NominationTeamNames[index].slug
              } else {
                emailSlug = emailSlug +','+ this.NominationTeamNames[index].slug
              }
            }
            urlString = '?slug='+emailSlug+'&type=TOM&selectionPeriod='+selectionPeriod
          }
          console.log('urlString : '+urlString, this.NominationTeamNames)
          WordpressRestAPI.getCustomViewContent('getNomination/v1/getUserNominationPerEOMBeforeSubmit'+urlString)
          .then(response => {
            console.log('review list-> ', response.data)
            if (response.data !== false) {
              console.log('review list-> ', response.data.EOM_count, response.data.TOM_count)
              //if (response.data && response.data.EOM_count && response.data.TOM_count) {
              if (response.data) {
                if (this.NominationTeamNames.length === 1) {
                  // Loop through user_count
                  this.createNominationError = ''
                  // Check if userStatus is false and alert
                  if (response.data.EOM_count > 0) {
                    this.submitClicked = true
                    alert(`User ${this.nominatedPerson} is already nominated 1 times for ${selectionPeriod}. Hence you can not nominate this user.`)
                  } else if (response.data.TOM_count > 0) {
                    this.submitClicked = true                    
                    alert(`User ${this.nominatedPerson} is already nominated 1 times for ${selectionPeriod}. Hence you can not nominate this user.`)
                  } else {
                    this.createNominationEntry()
                  }
                } else {
                  let proceedNomination = true
                  for (let index = 0; index < this.NominationTeamNames.length; index++) {
                    // Loop through user_count
                    this.createNominationError = ''
                    // Check if userStatus is false and alert
                    if (response.data.EOM_count[index] > 0) {
                      proceedNomination = false
                      alert(`User ${this.NominationTeamNames[index].slug} is already nominated 1 times for ${selectionPeriod}. Please remove this user to continue nomination.`)
                    } else if (response.data.TOM_count[index] > 0) {
                      proceedNomination = false
                      alert(`User ${this.NominationTeamNames[index].slug} is already nominated 1 times for ${selectionPeriod}. Please remove this user to continue nomination.`)
                    }
                  }
                  if (proceedNomination) {
                    this.createNominationEntry()
                  } else {
                    this.submitClicked = true   
                  }
                }

              }
            } else {
              this.contentReady = true
              this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
            }
          })
          .catch(e => {
              this.contentReady = true
              this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
              console.error(e)
          })
        } else {
          this.submitClicked = true
        }
      },
      fieldUpdated: function (fieldDetails) {
        console.log('fieldUpdated start nominationContent ', this.nominationContent)
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].label === fieldDetails.label) {
            this.nominationContent[i].content = fieldDetails.content
            this.nominationContent[i].validated = fieldDetails.validated
            this.nominationContent[i].displayField = fieldDetails.displayField
            break
          }
        }
        console.log('fieldUpdated end nominationContent ', this.nominationContent)
      },
      setNominationContent: function (nominationFields) {
        console.log('before setNominationContent ', this.nominationContent)
        console.log('before nominationFields ', this.nominationFields)
        
        var self = this
        self.nominationFields = nominationFields.map(function (x, index) {
        var displayFieldVal = x.display_field === "No" ? false : true
        return {
          type: x.form_field_type,
          description: x.field_description,
          secondaryDescription: x.field_secondary_description,
          isRequired: x.required_nomination_field,
          checkboxLabels: x.checkbox_labels,
          errorClass: '',
          index: index + x.form_field_type,
          description_lvl_two: x.description_lvl_two,
          secondary_description_lvl_two: x.secondary_description_lvl_two,
          display_field: displayFieldVal,
          validationMethod: x.validationmethod
        }
      })
        console.log('after setNominationContent ', this.nominationContent)
        console.log('after nominationFields ', this.nominationFields)

        if (self.nominationContent.length > 1) {
          self.nominationContent = self.nominationFields.map(function (x, i) {
            return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
          })
        } else  {
          self.nominationContent = self.nominationFields.map(function (x) {
            return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
          })
        }
      },
      loadContent: function () {
        this.madeNomination = false
        this.nominatedPerson = ''
        document.title = this.$route.name + ' - ThinkTank'
        WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=137&_embed&per_page=1')
        .then(response => {
          console.log(' response.data ', response.data)
          this.award = response.data[0]
          console.log(' this.award ', this.award, this.award.content.rendered)
          this.contentReady = true
          if (this.award.include_nomination_form[0] === 'Yes') {
            // Reinitiate every variable related with form
            this.NominationTeamNames = []
            this.isTeamAwards = true
            this.NominationButtonText = 'Add Nominee'
            this.NominationLabel = 'Employee of the Month Nomination'
            this.NominationPlaceholder = 'Search by email address, seperate multiple email by comma...'
            this.setNominationContent(this.award.nomination_fields[0][0])
          }
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
      },
      searchNomineeList: function (newQuery) {
        if ( newQuery.length > 2 )
        WordpressRestAPI.getCustomViewContent('getNominees/v1/nomineelist?search=' + newQuery)
          .then((res) => {
            this.nomineesList = res.data
            //console.log(' res.data ', res.data, newQuery)
          })
      }
    },
  created () {
    console.log(' viewEmployeeAwards ', this.viewEmployeeAwards)
    this.loadContent()
  },
  watch: {
    nominatedPerson (newQuery, oldQuery) { 
      if (newQuery != '')
        this.searchNomineeList(newQuery) 
    },
    '$route' (to, from) {
      this.contentReady = false
      this.loadContent()
    }
  }
}
  </script>
  
  <style lang="less">
    .featuredImg {
      img {
        width: 100%;
      }
    }
    .box {.icon { text-align: center; position: relative; }}
    .box { .icon { .image { position: relative; z-index: 2; width: 50px; height: 50px; line-height: 50px; border-radius: 50%; background: #09ced6; vertical-align: middle; }}}
    .box { .icon:hover { .image { background: #63B76C; }}}
    .box { .icon { .image { i { color: #fff !important; border: 1px solid white; padding: 10px; border-radius: 50%; min-width: 38px;}}}}
    .box { .icon { .info { margin-top: -45px; margin-left: 20px; padding: 15px 20px 10px 0px; }}}
    .box { .icon { .infoaqua { background-color:#CEF6F8; }}}
    .box { .icon { .infogrey { background-color:#F8F8F8; }}}
    .box { .icon { .infowhite { background-color:#FFFFFF; }}}
    .box { .icon { .info { h3 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
    .box { .icon { .info { h5 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
    .box { .icon { .info { ul {list-style: none; margin-left: 20px;}}}}
    .box { .icon { .info { ul { li::before { content: "\2022"; color: #09ced6; display: inline-block; width: 1em; margin-left: -1em;}}}}}
    .box { .icon { .info { .miniseparator {width: 55px; border-bottom: 5px solid #09ced6; margin-left: 50px;}}}}
    .box { .icon { .info { p {margin-left: 40px;}}}}
    .aquacolor {color:#09ced6;}
    .navycolor {color: navy;}
  </style>
  


// WEBPACK FOOTER //
// src/components/routes/VEAwardsEmployee.vue